export default "__VITE_ASSET__BjB7O_dK__"